<div class="w-full py-3 px-4">
  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-6"><mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style="mask-type: alpha"><rect width="24" height="24" fill="#C19725"></rect></mask><g mask="url(#mask0_848_1764)"><path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path></g></svg>
      <img src="/assets/images/stock/order.png" alt="Report" class="size-6 sm:size-8 lg:size-10"/>
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Assign & Manage Assets for {{ userType }} (Name: {{ kalakarName }})
      </span>
    </div>
  </div>
  <form [formGroup]="assignForm" (ngSubmit)="onAssignSubmit()">
    <div class="w-full mt-3 mb-4 bg-[#FFF5F2] p-3 rounded-md">
      <h3 class="font-semibold text-base mb-3 text-444">Assign a New Asset</h3>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
        <div class="md:col-span-3">
          <label for="assetToAssignId" class="block mb-2 text-sm font-medium text-gray-900">Available Assets in Inventory</label>
          <select id="assetToAssignId" formControlName="assetToAssignId" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option [ngValue]="null" disabled selected hidden>Choose an asset</option>
            <ng-container *ngIf="availableAssets.length > 0; else noAvailableAssets">
              <option *ngFor="let asset of availableAssets" [value]="asset.id">
                {{ asset.name }} (Value: {{ asset.value | currency:'INR' }})
              </option>
            </ng-container>
            <ng-template #noAvailableAssets>
              <option disabled>No available assets in inventory</option>
            </ng-template>
          </select>
        </div>
        <div class="md:col-span-1">
          <button type="submit" [disabled]="assignForm.invalid || isSubmitting" class="w-full text-white bg-c19725 hover:bg-c19725 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed">
            {{ isSubmitting ? 'Assigning...' : 'Assign Asset' }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="w-full py-3 px-4">
  <h3 class="font-semibold text-base sm:text-lg text-444 mb-2">Assets Currently Assigned to Kalakar</h3>
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
    <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
      <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
        <tr>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Asset Name</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Asset Value</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Status</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action</th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-xs">
        <tr *ngFor="let asset of assignedAssets; let i = index" class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]">
          <td class="p-3 text-center">{{ i + 1 }}</td>
          <td class="p-3 text-center">
             <span>{{ asset.name || "-" }}</span>
          </td>
          <td class="p-3 text-center">{{ asset.value | currency:'INR' }}</td>
          <td class="p-3 text-center">
            <span *ngIf="asset.return_requested_at" class="relative inline-flex items-center px-2 py-1 font-semibold leading-tight text-blue-700 bg-blue-100 rounded-full">
              <span class="absolute top-0 right-0 flex h-3 w-3 -mt-1 -mr-1">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
              </span>
              Return Requested
            </span>
            <!-- =========== TEXT CHANGED HERE =========== -->
            <span *ngIf="!asset.return_requested_at && asset.issue_reported_at && !asset.receipt_acknowledged_at" class="px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-full">
              Not Received
            </span>
            <span *ngIf="!asset.return_requested_at && asset.receipt_acknowledged_at" class="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full">
              Received
            </span>
            <span *ngIf="!asset.return_requested_at && !asset.receipt_acknowledged_at && !asset.issue_reported_at" class="px-2 py-1 font-semibold leading-tight text-yellow-700 bg-yellow-100 rounded-full">
              Pending Ack.
            </span>
          </td>
          <td class="p-3 text-center">
            <ng-container *ngIf="asset.return_requested_at">
              <button (click)="onReturnAsset(asset.id)" title="Approve Return Request" class="px-3 py-1.5 text-xs font-medium text-center text-white bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300">
                Approve Return
              </button>
            </ng-container>
            <ng-container *ngIf="!asset.return_requested_at">
              <span class="text-gray-400 text-xs italic">No action required</span>
            </ng-container>
          </td>
        </tr>
        <tr *ngIf="assignedAssets.length === 0">
          <td colspan="5" class="p-4 text-center text-gray-500">This Kalakar has no assigned assets.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
